export enum ContractNavigationEnum {
  INITIAL = 'INITIAL',
  TOKEN_REQUESTED = 'TOKEN_REQUESTED',
  TOKEN_VERIFIED = 'TOKEN_VERIFIED',
  PRE_CONTRACT = 'PRE_CONTRACT',
  DEVICE_DETAILS = 'DEVICE_DETAILS',
  SIGN_CONTRACT = 'SIGN_CONTRACT',
  CONTRACT_COMPLETED = 'CONTRACT_COMPLETED',
}
